import { PLAYER } from "@/data/portfolio";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0a0a0a] text-white border-t border-white/10 px-6 md:px-12 lg:px-24 py-10"
    >
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="font-display font-black uppercase tracking-tighter text-2xl">
          {PLAYER.firstName} {PLAYER.lastName}
          <span className="text-[#e63946]">.</span>
        </div>
        <div className="text-[11px] font-semibold uppercase tracking-[0.3em] text-neutral-400">
          © {year} — All rights reserved · Built for the pitch
        </div>
      </div>
    </footer>
  );
};
